import * as React from 'react';

import { Providers } from './providers';
import { Routes } from './routes';

import './assets/styles/global.css';

export default function App() {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}
